import React, { useEffect, useState } from 'react';
import { Alert, Form } from 'antd';
import { connect } from 'react-redux';
import AddCardComponent from 'src/components/shared/addCard.component';
import { useParams } from 'react-router-dom';
import SelectInput from 'src/components/shared/selectInput';
import CardComponent from './cards';
import apiCalls from 'src/api/apiCalls';
import NoData from 'src/components/shared/noDataComponent';
import Loader from 'src/components/loader.component';
const Cards = () => {

    const [physicalCardsData, setPhysicalCardsData] = useState([]);
    const [errorMsg, setErrorMsg] = useState(null);
    const [loader, setLoader] = useState(false);
    const [hide, setHide] = useState(false)
    const cardDivRef = React.useRef(null);
    const [addCardModalShow, setAddCardModalShow] = useState(false);
    const [type, setType] = useState('All')
    const { custId } = useParams();
    const [typeLu, setTypeLu] = useState(null);
    useEffect(() => {
        getphysicalCards(type);
    }, [type])
    useEffect(() => {
        getcardTypeLu();
    }, [])
    const getcardTypeLu = async () => {
        setErrorMsg(null)
        setLoader(true);
        let response = await apiCalls.getcardTypeLuData()
        if (response.ok) {
            setLoader(false); setTypeLu(response.data?.CardTypeLookup)
            setErrorMsg(null)
        }
        else {
            setErrorMsg(apiCalls.isErrorDispaly(response));
            setLoader(false);
        }
    }
    const handleInputChange = (e) => {
        const value = e ? e : 'All';
        setType(value);
    }
    const getphysicalCards = async (type) => {
        setLoader(true);
        let response = await apiCalls.getCards(custId, type)
        if (response.ok) {
            setHide(true)
            const groupedItems = response.data?.reduce((acc, item) => {
                const key = item.cardStatus;
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(item);
                return acc;
            }, {});
            const groupedItemsArray = Object.entries(groupedItems).map(([key, value]) => ({
                cardStatus: key,
                items: value,
            }));
            setPhysicalCardsData(groupedItemsArray);
            setLoader(false);
        }
        else {
            setErrorMsg(apiCalls.isErrorDispaly(response));
            cardDivRef.current.scrollIntoView(0, 0);
            setLoader(false);
            setHide(true)
        }
    }
    return (

        <>
            <div ref={cardDivRef}></div>
            {errorMsg !== undefined && errorMsg !== null && (
                <Alert variant="danger" className='alert-flex' description={errorMsg}
                    closable showIcon onClose={() => setErrorMsg(null)}
                    message="" >
                    <p style={{ color: 'red', margin: 10 }}><span className="icon error-alert me-2"></span>{errorMsg}</p>
                </Alert>

            )}
            <div className='loader-center'>
                {loader && <Loader />}
            </div>
            <div>
                <div className='md:w-56 mt-2'>
                    <div><Form.Item
                        className=""
                        name="cardType"
                    >
                        <SelectInput label="Select Card Type" fieldName="Card Type" defaultValue="All" options={typeLu} onChange={(value) => handleInputChange(value)} optionValue="code" allowClear={false} showSearch={false} />
                    </Form.Item></div>
                </div>
                {hide && <div>
                    {physicalCardsData !== null && physicalCardsData?.length === 0 && !loader && (
                        <NoData />
                    )}
                    {physicalCardsData?.length > 0 && physicalCardsData.map(item => (
                        <div className='flex gap-4 flex-wrap'>
                            {item.items.map(item => (
                                <CardComponent cardData={item} cardType={item.cardType} key={item?.id}></CardComponent>
                            ))}
                        </div>
                    ))}
                </div>}
            </div>
            {addCardModalShow && <AddCardComponent modal={addCardModalShow} onCancel={() => setAddCardModalShow(false)} onCardSave={() => setRefresh(true)} getphysicalCards={() => getphysicalCards()} />}
        </>
    )
}

const connectStateToProps = ({ userConfig, oidc }) => {
    return { userConfig: userConfig?.userProfileInfo, user: oidc?.user }
}

export default connect(connectStateToProps)(Cards)